// extracted by mini-css-extract-plugin
export default {"news":"singleNewsToDelete_news__Q-8T9","titel":"singleNewsToDelete_titel__MTjTx"};